import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FlashpackItem } from "../../common/api";

// Confirmation dialog shown before removing a card from a flashpack deck.
// Shown whenever `item` is set.
export const ConfirmItemRemovalModal = ({
  item,
  onCancel,
  onConfirm,
}: {
  item: FlashpackItem | undefined;
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={item !== undefined} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("flashpacks_confirm_remove_word_title", {
            word: `"${item?.item}"`,
          })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t("flashpacks_confirm_remove_word_body", {
          word: `"${item?.item}"`,
        })}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {t("generic_cancel")}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {t("generic_remove")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
